<template>
  <div class="tree-form">
    <!-- <div class="tree-form-title">商品分类管理</div> -->
    <tree-form ref="treeform"
      nodeKey='classId'
      :showKey="true"
      :max-level="3"
      :props="defaultProps"
      :fetchData="fetchData"
      @node:append="nodeAppend"
      @node:remove="nodeRemove"
      @node:edit="nodeEdit"
      @node:look="nodeLook"
      look-scope='last'
      :task="['append', 'remove','edit','look']" />
    <el-dialog :title="type === 'add' ? '新增分类' : '编辑分类'"
      :visible.sync="dialogVisible"
      width="400px"
      @closed="handleClose"
      :before-close="handleBeforeClose">
      <el-form :model="nodeData"
        :rules="rules"
        ref="ruleForm"
        label-width="90px">
        <el-form-item label="类别名称"
          prop="className">
          <el-input v-model="nodeData.className"></el-input>
        </el-form-item>
        <el-form-item label="类别ID"
          prop="classId">
          <el-input-number style="width:100%"
            v-model="nodeData.classId"
            :precision="0"
            :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item label="上级类别"
          v-if="nodeData.parentId">
          {{nodeData.parentId ? nodeData.parentLabel : '无'}}
        </el-form-item>
      </el-form>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary"
          @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TreeForm from '@/components/public/tree-form.vue'
import _ from 'lodash'
export default {
  name: 'industry-category-form',
  components: { TreeForm },
  props: {},
  data () {
    return {
      dialogVisible: false,
      defaultProps: {
        label: 'className',
        children: 'children'
      },
      nodeData: {},
      type: '',
      rules: {
        className: [{ required: true, message: '请输入类别名称', trigger: 'blur' }],
        classId: [{ required: true, message: '请输入类别ID', trigger: 'blur' }]
      },
      current: null
    }
  },
  watch: {},
  computed: {},
  methods: {
    handleBeforeClose (done) {
      this.cancel && this.cancel()
      done()
    },
    handleCancel () {
      this.dialogVisible = false
      this.cancel && this.cancel()
    },
    handleSubmit () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.type === 'add') {
            this.$store.dispatch('industry/addcategory', {
              payload: {
                ...this.nodeData,
                parentClassId: this.nodeData.parentId
              },
              success: (res) => {
                this.loading = false
                this.callback && this.callback()
                this.dialogVisible = false
              },
              fail: () => {
                this.loading = false
              }
            })
          }
          if (this.type === 'edit') {
            this.$store.dispatch('industry/updatecategory', {
              payload: {
                ...this.nodeData,
                parentClassId: this.nodeData.parentId
              },
              success: (res) => {
                this.loading = false
                this.callback && this.callback()
                this.dialogVisible = false
              },
              fail: () => {
                this.loading = false
              }
            })
          }
        }
      })
    },
    handleClose () {
      this.callback = null
      this.nodeData = {}
      this.cancel = null
      this.type = ''
      this.$refs.ruleForm.resetFields()
    },
    fetchData ({ callback, fail }) {
      this.$store.dispatch('industry/getallcategorys', {
        payload: {},
        success: (res) => {
          callback(res.data.categorys)
          if (this.current) {
            this.$nextTick(() => {
              this.$refs.treeform.getTreeRefs().setCurrentKey(this.current.classId)
            })
          }
        },
        fail: () => {
          fail && fail()
        }
      })
    },
    nodeAppend ({ data, callback, cancel }) {
      this.callback = callback
      this.cancel = cancel
      this.nodeData = _.cloneDeep(data)
      this.type = 'add'
      this.dialogVisible = true
    },
    nodeEdit ({ data, callback, cancel }) {
      this.callback = callback
      this.cancel = cancel
      this.nodeData = _.cloneDeep(data)
      this.type = 'edit'
      this.dialogVisible = true
    },
    nodeRemove ({ data, callback, cancel }) {
      this.$confirm('此操作将永久删除该类别, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('industry/deletecategory', {
            payload: data,
            success: (res) => {
              this.loading = false
              callback && callback()
            },
            fail: () => {
              this.loading = false
              cancel && cancel()
            }
          })
        })
        .catch(() => {
          cancel && cancel()
        })
    },
    nodeLook ({ data, callback, cancel }) {
      this.current = data
      this.$emit('emit:task', data)
    }
  },
  created () { },
  mounted () { }
}
</script>
<style lang="stylus">
.tree-form {
  .el-input-number {
    .el-input__inner {
      text-align: left;
    }
  }
}
</style>
